import { PRODUCT_IDS } from '@adsk/alloy-provider';
const adminProductIds = [PRODUCT_IDS.PROJECT_ADMINISTRATION, PRODUCT_IDS.ACCOUNT_ADMINISTRATION];
export default (function () {
  let products = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  const firstAdminProduct = products.find(product => adminProductIds.includes(product.key));
  if (products[0] === firstAdminProduct) return undefined;
  return firstAdminProduct === null || firstAdminProduct === void 0 ? void 0 : firstAdminProduct.key;
});
//# sourceMappingURL=getFirstAdminProduct.js.map